export const wrapperStyles = {
  gap: '8px',
  flex: 1,
  height: '100%',
  overflow: 'hidden',
  padding: 0,
};

export const tableClassName = 'flex-1 overflow-hidden p-1';
